import { trimDecimals } from './numbers';

export const DEFAULT_USD_MAX_DECIMALS = 2;

export const WEI_CONVERSION_RATE = Math.pow(10, 18);
export const OCT_CONVERSION_RATE = Math.pow(10, 8);

export function convertWeiToEth(amount = 0, maxDecimals?: number) {
    const converted = amount / WEI_CONVERSION_RATE;

    if (converted < 1) return converted;

    return trimDecimals(converted, maxDecimals);
}

export function convertEthToWei(amount = 0) {
    const converted = Math.round(amount * WEI_CONVERSION_RATE);
    return Number(
        BigInt(converted).toLocaleString('fullwide', {
            notation: 'standard',
            useGrouping: false,
        }),
    );
}

export function convertEthToUsd(amount = 0, conversionRate = 1, maxDecimals = DEFAULT_USD_MAX_DECIMALS) {
    const converted = amount * conversionRate;

    if (converted < 1) return converted;

    return trimDecimals(converted, maxDecimals);
}

export function convertOctToAptos(octAmount = 0, maxDecimals?: number) {
    const converted = octAmount / OCT_CONVERSION_RATE;

    if (converted < 1) return converted;

    return trimDecimals(converted, maxDecimals);
}

export function intToPx(value = 0) {
    return `${value}px`;
}
